'usr strict';

import controller from './reconfirmacion.controller';
import template from './reconfirmacion.html';
import service  from '../../../integracion-siga/integracion.service';

const ReconfirmacionUsuariosComponent = {
  bindings: {
    usuario: '=',
    api: '@?'
  },
  controller,
  template,
  service
};

export default ReconfirmacionUsuariosComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/usuarios/reenviar-confirmacion/reconfirmacion.component.js